import CustomCard from "../../../../../components/CustomCard";
import { CustomCheckbox } from "../../../../../components/CustomCheckbox";
import {
    IconCheckboxChecked,
    IconCheckboxUnchecked,
    IconCloseChip,
    IconMealBowl
} from "../../../../../components/buttons/IconButtons";
import CustomTooltip from "../../../../../components/CustomTooltip";
import React from "react";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 *
 * Selected cafeteria (diner) card for the foodie shift Add/Assigned tabs. Shows
 * the cafeteria name with an optional delete action and an optional selection
 * checkbox. Mirrors the attendance SelectedDeviceCard.
 *
 * @param {Object} props
 * @param {string} props.keyId - Identifier field name used for the item.
 * @param {Object} props.item - Cafeteria row ({ [keyId], fullName, checked, disabled }).
 * @param {Function} [props.onDelete] - Callback invoked with the item when removed.
 * @param {Function} [props.handleCheckboxChange] - Selection handler; when set, renders the checkbox.
 * @returns {JSX.Element}
 */
const SelectedCafeteriaCard = (
    {
        keyId,
        item,
        onDelete,
        handleCheckboxChange
    }
) => {

    return (
        <CustomCard
            classes="w-100"
            classCard="card-border-8px"
            classContent={`background-shades-50`}
        >
            <div className="row">
                <div className={"d-flex justify-content-between p-0"}>
                    {handleCheckboxChange &&
                        <div className={"align-top mr-3"}>
                            <CustomCheckbox
                                id={'cb_scc_row_' + keyId}
                                checked={item?.checked}
                                onChange={(e) => {
                                    handleCheckboxChange({
                                        target: {
                                            [keyId]: item[keyId],
                                            checked: e.target.checked,
                                        },
                                    });
                                }}
                                disabled={item?.disabled}
                                disableRipple={true}
                            />
                        </div>
                    }

                    <div className={"flex-grow-1 minw-0 mr-1 mt-2"}>
                        <div className="d-flex align-items-center justify-content-between">
                            <div className={`col-12 p-0`}>
                                <div className='d-flex align-items-center justify-content-start'>
                                    <div><IconMealBowl className="mr-8px mb-1" /></div>
                                    <div className={`mr-5 flex-grow-1 minw-0 p-0`}>
                                        <CustomTooltip
                                            text={item?.fullName}
                                            classes={`fs-14px font-color-general-950 ibl-font-w-600 text-ellipsis-1-row `}
                                            showIfTruncated={true}
                                        />
                                    </div>
                                    {onDelete &&
                                        <div className={"position-absolute r-0px t-negative-4px"}>
                                            <IconCloseChip
                                                className='icon-color-shades-400 icon-hover-shades-950'
                                                onClick={() => onDelete(item)}
                                            />
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </CustomCard>
    );
}
export default SelectedCafeteriaCard
